import banner from "../../../courses/module-1/img3.png";

const modulo3 = {
  courseId: "finanzas-personales",
  id: "modulo-3",
  title: "📘 MÓDULO 3: Ahorro con Propósito",
  estimatedDuration: "2 horas",
  format: "Lectura + ejercicios + tarea práctica",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 Objetivos del módulo",
      content: [
        "Comprender por qué ahorrar sin propósito puede ser desmotivante.",
        "Identificar diferentes tipos de ahorro que se adaptan a tu realidad como estudiante.",
        "Diseñar un plan de ahorro personalizado con metas claras, alcanzables y motivadoras.",
      ],
    },
    {
      id: "lectura",
      navLabel: "Lectura principal",
      title: "📖 Lectura principal: ¿Ahorrar por ahorrar? No siempre funciona",
      content: [
        {
          type: "paragraph",
          text: "Muchas veces nos dicen “tienes que ahorrar,” pero no nos explican para qué ni cómo. El problema de ahorrar sin un propósito definido es que:",
        },
        {
          type: "list",
          items: [
            "Es fácil romper el ahorro por cualquier impulso o gasto emocional.",
            "No hay una motivación clara que te anime a seguir.",
            "Puedes sentir que estás guardando sin sentido y rendirte rápido.",
          ],
        },
        {
          type: "paragraph",
          text: "El verdadero motor del ahorro es tener una meta concreta, personal y emocionalmente significativa.",
        },
      ],
    },
    {
      id: "tipos",
      navLabel: "Tipos de ahorro",
      title: "🧩 Tipos de ahorro",
      content: [
        {
          type: "table",
          headers: ["Tipo", "¿Para qué sirve?", "Ejemplo real"],
          rows: [
            [
              "Fondo de emergencia",
              "Para imprevistos: enfermedades, accidentes, pérdidas",
              "Tener $2,000 pesos guardados para “lo que sea”",
            ],
            [
              "Ahorro para metas",
              "Para cosas específicas, con fecha y monto claro",
              "Pagar el pasaporte, comprar una laptop, ir a un retiro",
            ],
            [
              "Ahorro a largo plazo",
              "Para proyectos mayores o independencia personal",
              "Mudarte solo, emprender un negocio, estudiar posgrado",
            ],
          ],
        },
      ],
    },
    {
      id: "estrategias",
      navLabel: "Estrategias",
      title: "🛠 Estrategias de ahorro para estudiantes",
      content: [
        {
          type: "list",
          items: [
            "Método del 10%: guarda el 10% de todo ingreso, por pequeño que sea.",
            "Ahorro visual: imprime una imagen de tu meta y colócala donde la veas diario.",
            "Sistema de sobres (físico o digital): divide tu dinero en categorías.",
            "Redondeo inteligente: si gastas $93, guarda los $7 restantes como “cambio fantasma”.",
            "Apps útiles: Fintonic, Presupuesto Familiar MX, Money Manager.",
            "Ahorro en comunidad: haz tandas con amigxs o familiares de confianza.",
          ],
        },
      ],
    },
    {
      id: "meta-smart",
      navLabel: "Meta SMART",
      title: "🧠 ¿Cómo definir una meta de ahorro SMART?",
      content: [
        {
          type: "orderedList",
          items: [
            "Específica: ¿Qué quiero lograr exactamente?",
            "Medible: ¿Cuánto dinero necesito?",
            "Alcanzable: ¿Es realista con mi situación?",
            "Relevante: ¿Por qué esta meta me importa?",
            "Tiempo: ¿En cuánto tiempo quiero lograrlo?",
          ],
        },
        {
          type: "paragraph",
          text: "Ejemplo: “Quiero ahorrar $1,500 para comprar un celular nuevo en 3 meses, guardando $125 cada semana.”",
        },
      ],
    },
    {
      id: "tabla-smart",
      navLabel: "Tabla SMART",
      title: "📋 Tabla interactiva de metas SMART",
      content: [
        {
          type: "link",
          href: "https://docs.google.com/spreadsheets/d/1Dxejb_qtBMcCADWzIDMf7K-s0r0Oplr14FMMzXyHzss/edit?gid=0",
          text: "Accede aquí a la tabla de metas SMART",
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Actividad",
      title: "🧠 Ejercicio de reflexión",
      content: [
        "1.Piensa en algo que deseas conseguir y respóndete en tu cuaderno:",
        {
          type: "list",
          items: [
            "¿Qué quiero?",
            "¿Cuánto cuesta?",
            "¿Cuándo lo necesito?",
            "¿Cuánto puedo guardar por semana/mes?",
            "¿Qué gasto puedo reducir para lograrlo?",
          ],
        },
        "2.Escribe tu meta SMART completa.",
        "3.Llena la tabla con esa información.",
      ],
    },
    {
      id: "lectura-complementaria",
      navLabel: "Lectura complementaria",
      title: "📚 Lectura complementaria",
      content: [
        {
          type: "link",
          href: "https://www.pequenocerdocapitalista.com",
          text: "¿Cómo fijar metas que sí cumples? – Blog Pequeño Cerdo Capitalista",
        },
      ],
    },
    {
      id: "piramide",
      navLabel: "Pirámide de inversión",
      title: "🔺 Extra: ¿Qué es la pirámide de inversión?",
      content: [
        {
          type: "paragraph",
          text: "La pirámide de inversión es un modelo visual que muestra cómo deberías distribuir tu dinero cuando empiezas a invertir, empezando por lo más seguro y avanzando hacia lo más arriesgado, de forma gradual y estratégica.",
        },
        {
          type: "table",
          headers: [
            "Nivel",
            "Tipo de inversión",
            "Características",
            "Ejemplos comunes",
          ],
          rows: [
            [
              "Base",
              "Ahorro y seguridad",
              "Bajo riesgo, alta liquidez, protección",
              "Cuenta de ahorro, CETES, tandas",
            ],
            [
              "Crecimiento moderado",
              "Riesgo medio, retorno mediano-largo plazo",
              "Fondos de inversión, pagarés bancarios",
              "",
            ],
            [
              "Rendimiento alto",
              "Mayor riesgo, posible alta ganancia",
              "Criptomonedas, acciones, startups",
              "",
            ],
          ],
        },
      ],
    },
    {
      id: "evaluacion",
      navLabel: "Evaluación rápida",
      title: "📝 Evaluación rápida",
      content: [
        "Tarea: Crear tu plan de ahorro con meta SMART",
        "📌 ¿Qué debe contener?",
        {
          type: "list",
          items: [
            "Tu meta específica y motivadora",
            "Monto total a ahorrar",
            "Tiempo estimado",
            "Plan semanal o mensual para lograrlo",
            "Método de ahorro (alcancía, app, banco, tanda…)",
          ],
        },
      ],
    },
    {
      id: "bibliografia",
      navLabel: "Bibliografía",
      title: "📚 Bibliografía para profundizar",
      content: [
        "Sofía Macías – “Pequeño Cerdo Capitalista: Inversiones”",
        "CONDUSEF – “Ahorro para jóvenes”",
        "Ramsey Solutions – “Los pasos del ahorro con propósito”",
      ],
    },
    {
      id: "frase",
      navLabel: "Frase del día",
      title: "🧠 Frase del día",
      content: [
        "“Ahorrar no es guardar lo que te sobra, sino elegir guardar lo que te acerca a tus sueños.”",
      ],
    },
  ],
};

export default modulo3;
